import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * /join?ref=PETSO-XXXX-YYYY — Referral landing page.
 * Captures the referral code from the URL, stores it in sessionStorage,
 * then redirects to the login/signup page where AuthContext picks it up.
 */
export const Route = createFileRoute('/join')({
  component: JoinPage,
});

function JoinPage() {
  // Read the ?ref= query parameter from the current URL
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');

  if (ref) {
    // Store the referral code so AuthContext can use it during sync
    try {
      sessionStorage.setItem('petso_referral_code', ref);
    } catch {
      // sessionStorage might be unavailable in private mode
    }
  }

  // Redirect to login page (sign-up mode will be shown)
  return <Navigate to="/login" replace />;
}
